import React from 'react'

import InnerHTML from "dangerously-set-html-content";

export default class SafeHtml extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      html: props.html,
      hasError: false
    }
  }

  render() {
    let {
      html
    } = this.state

    try {
      return <InnerHTML html={html} />;
    } catch (error) {
      console.error("Failed to render HTML content:", error);
    }
  }
}
